<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Route Wizard</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" data-test="listHeader">
        Congratulations - (Step 8 of 8)
    </ion-list-header>

    <ion-list class="ion-margin">
        <ion-label class="ion-text-wrap">
            You have successfully completed the following items:
            <ul>
                <li>Shuttle Selection</li>
                <li>Ticket Selection</li>
                <li>Route Verification</li>
                <li>Route Saving</li>
                <li>Sending SMS To Ticket Holders</li>
            </ul>
        </ion-label>

        <ion-label class="ion-text-wrap">
            The route for <strong>'{{vm.selectedShuttle.shuttleName}}'</strong> has 
            been determined and you are now ready to start navigating.
        </ion-label>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-button color="primary" expand="full" (click)="onRoutesClick()" data-test="goToRoutes">
                        Go to Routes
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button color="primary" expand="full" (click)="onNavigationClick()" data-test="goToNavigation">
                        Go to Navigation
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-footer>